// index.html に直接書かれている文言を、data-i18n 属性を頼りに現在の言語へ差し替える。
// マークアップ側は「どの文言か」だけを持ち、文字列そのものは i18n.ts の 1 箇所に集まる。
// 文言は 1 ページの中で変わらないので、起動時に 1 度だけ流す。
import { t, withLang, type Lang } from "../i18n";

const SETTERS: [attr: string, apply: (el: HTMLElement, text: string) => void][] = [
  ["data-i18n", (el, text) => (el.textContent = text)],
  ["data-i18n-aria", (el, text) => el.setAttribute("aria-label", text)],
  ["data-i18n-placeholder", (el, text) => el.setAttribute("placeholder", text)],
  ["data-i18n-title", (el, text) => el.setAttribute("title", text)],
];

export function applyStaticI18n(lang: Lang, explicitLang = false, root: ParentNode = document): void {
  const dict = t(lang) as unknown as Record<string, unknown>;

  for (const [attr, apply] of SETTERS) {
    for (const el of root.querySelectorAll<HTMLElement>(`[${attr}]`)) {
      const text = dict[el.getAttribute(attr) ?? ""];
      // 文言を引けないキーは、既定言語のまま置いておく（空文字で潰さない）。
      if (typeof text === "string") apply(el, text);
    }
  }

  // サイト内リンクは言語を引き継ぐ。data-lang-href が素のパス、href が実際の遷移先。
  for (const el of root.querySelectorAll<HTMLAnchorElement>("[data-lang-href]")) {
    el.href = withLang(el.dataset.langHref ?? "/", lang, explicitLang);
  }
}
